import { ConfirmationDialogPayload } from '@components/base-elements/confirmation-dialog/confirmation-dialog.component';

export function buildConsensusDeleteWarning(
  consensusCycleCount: number,
  descriptionBaseKey: string,
): Partial<ConfirmationDialogPayload> {
  if (consensusCycleCount <= 0) {
    return {};
  }

  const suffix = consensusCycleCount === 1 ? 'SINGULAR' : 'PLURAL';

  return {
    description: `${descriptionBaseKey}_${suffix}`,
    descriptionParams: { count: consensusCycleCount },
    confirmationCheckbox: `CONSENSUS.DELETE_WARNING.ACKNOWLEDGE_${suffix}`,
  };
}
